import {
  Grid,
  Box as MuiBox,
  Button as MuiButton,
  Typography,
} from '@mui/material';
import { useDispatch } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { UpdateApplicationRoute } from 'src/redux/actions/Application';

interface ConfirmationWithBackButtonType {
  icon?: string;
  title: string;
  subtitle: string;
  image?: string;
  message?: string | JSX.Element;
  goBackLink?: string;
}

const ConfirmationWithBackButton = ({
  icon,
  title,
  subtitle,
  image,
  message,
  goBackLink,
}: ConfirmationWithBackButtonType) => {
  const history = useHistory();
  const dispatch = useDispatch();

  const handleBackClick = (url: string) => {
    dispatch(UpdateApplicationRoute(url));
    history.push(url);
  }

  return (
    <div style={{ position: 'relative', height: 'auto', minHeight: '830px', marginBottom:'20px', paddingTop:"150px" }}>

      {icon && <MuiBox display="flex" justifyContent="center" marginBottom={3}>
          <img className="image" src={icon} alt="" width="50px" height="50px" style={{ display: 'block' }}/>
      </MuiBox>}

      <Grid
        container
        justifyContent="center"
        alignItems="center"
        spacing={1}
        padding={5}
        paddingTop={0}
        textAlign="center"
      >

        <Grid item xs={12} md={10} lg={9}>
          <Typography
            variant="h2"
            fontFamily="Ivar Display"
          >
            {title.split('<br>').map((elt)=><div key={elt}>{elt}<br/></div>)}
          </Typography>
        </Grid>
        <Grid item xs={12} md={10} lg={9}>
          <Typography variant="body1">{subtitle}</Typography>
        </Grid>

        {image && (
          <Grid item xs={12} md={10} lg={9}>
            <MuiBox
              display="flex"
              justifyContent="center"
              alignItems="center"
              sx={{ bottom: 0 }}
              width="100%"
            >
              <MuiBox
                height="100%"
                width={{ xs: '100vw', md: '80vh' }}
                minWidth={{ md: 600 }}
              >
                <img
                  alt="compliance"
                  src={image}
                  width="100%"
                  height="100%"
                  style={{ display: 'block' }}
                />
              </MuiBox>
            </MuiBox>
          </Grid>
        )}

        <Grid item xs={12} md={10} lg={9}>
            <MuiButton
              variant="contained"
              onClick={() => goBackLink ? handleBackClick(goBackLink) : history.goBack()}
              sx={{ width: {xs: '100%', sm: 100} }}
            >
              Go Back
            </MuiButton>
        </Grid>

        {message &&
          <Grid item xs={12} md={10} lg={9} marginTop={7}>
            {message}
          </Grid>
        }
      </Grid>
    </div>
  );
};

export default ConfirmationWithBackButton;
